import PaymentProcessingLayout from 'app/src/views/settings/paymentProcessing/PaymentProcessingLayout';
import PaymentProcessingController from 'app/src/controllers/settings/paymentProcessing/PaymentProcessingController';
import GatewayTerminalListViewController from 'app/src/controllers/settings/paymentProcessing/GatewayTerminalListViewController';
import GatewayLSPaymentsViewController from 'app/src/controllers/settings/paymentProcessing/GatewayLSPaymentsViewController';
import GatewayConfigCollection from 'app/src/data/models/GatewayConfigCollection';
import CCTerminalCollection from 'app/src/data/models/CCTerminalCollection';
import _ from 'underscore';

export default class PaymentProcessingViewController extends PaymentProcessingController {
  /**
   * Constructs, gathers all the Gateways and the Terminals information to iterate through Gateways and create
   * ChildViews for each.
   *
   * @param gatewayConfigs {Collection}
   * @param ccTerminals {Collection}
   */
  constructor(gatewayConfigs, ccTerminals) {
    if (
      !(gatewayConfigs instanceof GatewayConfigCollection) ||
      !(ccTerminals instanceof CCTerminalCollection)
    ) {
      throw 'A gateway and terminal collection must be specified';
    }

    super();

    const filteredLSPaymentsGatewayConfigs = new GatewayConfigCollection(
      gatewayConfigs.filter(
        gatewayConfig => gatewayConfig.get('gatewayID') === 'lightspeed-payments'
      )
    );

    /**
     * This is to remove the first empty Gateway which is attached
     * to a brand new user by default, but is invalid for real world use.
     */
    const filteredGatewayConfigs = new GatewayConfigCollection(
      gatewayConfigs.filter(
        gatewayConfig =>
          !(
            (gatewayConfig.get('name') === '' && gatewayConfig.get('gatewayConfigID') === 1) ||
            gatewayConfig.get('gatewayID') === 'lightspeed-payments'
          )
      )
    );

    this._gatewayLSPaymentConfigs = filteredLSPaymentsGatewayConfigs;
    this._gatewayConfigs = filteredGatewayConfigs;
    this._ccTerminals = ccTerminals;

    // initialize the controller's managed view.
    // We need viewData here for the Handlebars logic which shows a message if there are no Gateways.
    this.view = new PaymentProcessingLayout({
      viewData: {
        gatewayLSPaymentExist: this._gatewayLSPaymentConfigs.length,
        gatewaysExist: this._gatewayConfigs.length,
      },
    });
  }

  /**
   * Show method that initiates the GatewayTerminalListViewController (which displays a single Gateway listing)
   * to be attached to a dynamically created region, with the id of gateway-${gatewayID}.
   * We pass the gateway (for the info), terminal (to list the associated Terminal attached to this gateway)
   * and the shop (to create a Last Used Shop location entry).
   */
  show() {
    super.show();

    if (this._gatewayLSPaymentConfigs.length) {
      const gatewayRegion = 'banner_lspayments';

      this.createRegion(gatewayRegion, 'div.listings');
      this.attachChildViewController(new GatewayLSPaymentsViewController(), gatewayRegion);
    }

    if (this._gatewayConfigs.length) {
      this._gatewayConfigs.forEach(gateway => {
        const gatewayID = gateway.id;
        const terminals = new CCTerminalCollection(
          this._ccTerminals.filter(terminal => terminal.get('gatewayConfigID') === gatewayID)
        );
        const gatewayRegion = `gateway-${gatewayID}`;

        this.createRegion(gatewayRegion, 'div.listings');
        this.attachChildViewController(
          new GatewayTerminalListViewController(gateway, terminals),
          gatewayRegion
        );
      });
    }
  }
}
